import React from 'react';

import { CommonInputProps, FormInputWrapper } from './FormInputInternals';
import { Input } from './Input';

interface FormInputProps extends CommonInputProps {
    placeholder: string;
    optional?: boolean;
    type?: 'text' | 'password' | 'email' | 'date';
    autoComplete?: string;
    autoFocus?: boolean;
    normalize?: (value: string) => string;
}
export const FormInput = ({
    name,
    label,
    placeholder,
    description,
    vertical = false,
    optional = false,
    disabled = false,
    onBlur: onCustomBlur,
    onFocus: onCustomFocus,
    type = 'text',
    autoComplete = 'off',
    autoFocus = false,
    hideLabel,
    normalize,
}: FormInputProps) => {
    return (
        <FormInputWrapper
            {...{ name, label, description, vertical, disabled, hideLabel }}
            fieldRenderer={({ field: { onChange, value = '', onBlur } }) => (
                <Input
                    autoComplete={autoComplete}
                    autoFocus={autoFocus}
                    disabled={disabled}
                    id={name}
                    placeholder={placeholder}
                    onBlur={(ev) => {
                        onBlur();
                        onCustomBlur?.(ev);
                    }}
                    onChange={(ev) => {
                        onChange(normalize ? normalize(ev.target.value) : ev.target.value);
                    }}
                    onPaste={
                        normalize
                            ? (ev) => {
                                  ev.preventDefault();
                                  const pasted = ev.clipboardData.getData('text');
                                  onChange(normalize(pasted));
                              }
                            : undefined
                    }
                    onFocus={(ev) => {
                        onCustomFocus?.(ev);
                    }}
                    $optional={optional}
                    type={type}
                    value={value}
                />
            )}
        />
    );
};
